export default "__VITE_ASSET__4a63ef23__"